import React from 'react'
import languages from './languages'



const Skills = () => {

  return (
    <div className='services' style={{ "margin-top": "30px" }}>
    {/* <h5 className="text-center" style={{ "font-size": "18px" }}>DATA BUNDLES</h5> */}
    <h5 className="header text-center" style={{ "font-weight": "bold","color": "#893101"  }}>  Data Price List</h5>
  
    <div className="row mx-auto px-3 serviceNetwork">
        <div className="col-12 col-sm-6 col-md-2 pt-2 serviceCov">
              <div className="wrapper1 d-block mx-auto border ">
                   <div className='wrapperImageBody1'>
                                        
                         <img src="assets/mtn.png" alt="" className='wrapperImage' />
                         
                   </div>
                   <hr className='' style={{ "color":"gray", "margin-top":"38px" }}/>
                    <p>500.0MB <span className=''style={{ "margin-left":"15px" }}>₦122</span>	<span className=''style={{ "margin-left":"40px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 1.0GB<span className=''style={{ "margin-left":"40px" }}>₦230</span>	<span className=''style={{ "margin-left":"40px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 2.0GB<span className=''style={{ "margin-left":"40px" }}>₦477</span>	<span className=''style={{ "margin-left":"40px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 3.0GB<span className=''style={{ "margin-left":"40px" }}>₦715</span>	<span className=''style={{ "margin-left":"40px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 5.0GB<span className=''style={{ "margin-left":"40px" }}>₦1191</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 10.0GB<span className=''style={{ "margin-left":"30px" }}>₦2383</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <div className='contbtn'>
                    <a
                    href="https://sabuss.com/latoof6/?register" 
                    className="btnn text-light"
                 > 
                      <p> Download to see all plans</p>
                </a>
                    </div>
              </div>
        </div>
        <div className="col-12 col-sm-6 col-md-2 pt-2 serviceCov">
              <div className="wrapper1 d-block mx-auto border ">
                   <div className='wrapperImageBody2'>
                                        
                         <img src="assets/glo.png" alt="" className='wrapperImage' />
                         
                   </div>
                   <hr className='' style={{ "color":"gray", "margin-top":"38px" }}/>
                    <p>200.0MB <span className=''style={{ "margin-left":"15px" }}>₦084</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 500.0MB<span className=''style={{ "margin-left":"20px" }}>₦126</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 1.0GB<span className=''style={{ "margin-left":"40px" }}>₦246</span>	<span className=''style={{ "margin-left":"40px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 2.0GB<span className=''style={{ "margin-left":"40px" }}>₦493</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 3.0GB<span className=''style={{ "margin-left":"40px" }}>₦739</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 5.0GB<span className=''style={{ "margin-left":"30px" }}>₦1231</span>	<span className=''style={{ "margin-left":"40px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 10.0GB<span className=''style={{ "margin-left":"30px" }}>₦2463</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <div className='contbtn'>
                    <a
                    href="https://sabuss.com/latoof6/?register" 
                    className="btnn1 text-light"
                 > 
                      <p> Download to see all plans</p>
                </a>
                    </div>
              </div>
        </div>
        <div className="col-12 col-sm-6 col-md-2 pt-2 serviceCov">
              <div className="wrapper1 d-block mx-auto border ">
                   <div className='wrapperImageBody3'>
                                        
                         <img src="assets/airtel.png" alt="" className='wrapperImage' />
                         
                   </div>
                   <hr className='' style={{ "color":"gray", "margin-top":"38px" }}/>
                    <p>500.0MB <span className=''style={{ "margin-left":"15px" }}>₦129</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 1.0GB<span className=''style={{ "margin-left":"40px" }}>₦247</span>	<span className=''style={{ "margin-left":"40px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 2.0GB<span className=''style={{ "margin-left":"40px" }}>₦494</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 5.0GB<span className=''style={{ "margin-left":"40px" }}>₦1236</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 10.0GB<span className=''style={{ "margin-left":"30px" }}>₦2472</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 15.0GB<span className=''style={{ "margin-left":"30px" }}>₦3708</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 20.0GB<span className=''style={{ "margin-left":"30px" }}>₦4944</span>	<span className=''style={{ "margin-left":"20px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <div className='contbtn'>
                    <a
                    href="https://sabuss.com/latoof6/?register" 
                    className="btnn2 text-light"
                 > 
                      <p> Download to see all plans</p>
                </a>
                    </div>
              </div>
        </div>
        <div className="col-12 col-sm-6 col-md-2 pt-2 serviceCov">
              <div className="wrapper1 d-block mx-auto border ">
                   <div className='wrapperImageBody4'>
                                        
                         <img src="assets/9mobile.png" alt="" className='wrapperImage' />
                         
                   </div>
                   <hr className='' style={{ "color":"gray", "margin-top":"38px" }}/>
                    <p>500.0MB <span className=''style={{ "margin-left":"15px" }}>₦496</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 1.5GB<span className=''style={{ "margin-left":"40px" }}>₦990</span>	<span className=''style={{ "margin-left":"40px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 2.0GB<span className=''style={{ "margin-left":"40px" }}>₦1188</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 4.5GB<span className=''style={{ "margin-left":"40px" }}>₦1981</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 7.0GB<span className=''style={{ "margin-left":"40px" }}>₦1486</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 11.0GB<span className=''style={{ "margin-left":"30px" }}>₦3961</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <p> 15.0GB<span className=''style={{ "margin-left":"30px" }}>₦4952</span>	<span className=''style={{ "margin-left":"30px", "font-size":"15px" }}>30 days</span></p>
                    <hr className='' style={{ "color":"gray", "margin-top":"-20px" }}/>
                    <div className='contbtn'>
                    <a
                    href="https://sabuss.com/latoof6/?register" 
                    className="btnn3 text-light"
                 > 
                      <p> Download to see all plans</p>
                </a>
                    </div>
              </div>
        </div>
      
    </div>
</div>

  )

}

export default Skills